/// <amd-module name="Agile/Common/BoardsHubConstants" />
export const BoardPivotName = "board";
export const DirectoryPivotName = "directory";
